// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const SignOut: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 13"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                d="M5.25 12.219a.655.655 0 01-.656.656H2.625A2.625 2.625 0 010 10.25v-7A2.625 2.625 0 012.625.625h1.969a.655.655 0 110 1.313H2.625c-.722 0-1.313.59-1.313 1.312v7c0 .722.591 1.313 1.313 1.313h1.969c.363 0 .656.292.656.656zm8.572-5.917a.612.612 0 01-.05.897l-3.475 3.72a.653.653 0 01-.478.206.766.766 0 01-.45-.179.655.655 0 01-.029-.927l2.46-2.613H5.007c-.338 0-.632-.295-.632-.656 0-.36.293-.656.632-.656h6.816L9.391 3.482a.656.656 0 11.956-.9l3.475 3.72z"
            />
        </svg>
    );
};

export default React.memo(SignOut);
